import React, { Fragment, useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import HeaderComponent from "../../components/HeaderComponent";
import TitleH2Component from "../../components/TitleH2Component";
import { actualizarVentaR, actualizarVentaRD, cambiarClienteCotizacion, deleteVentaRD, obtenerDetalleventaR, postAbonoVR } from "../../api/ApiVenta";
import TitleH4Component from "../../components/TitleH4Component";
import InputComponent from "../../components/InputComponent";
import stylebtn from "../../styles/btn.module.scss";
import { Icon } from "@iconify/react/dist/iconify.js";
import ParrafoComponent from "../../components/ParrafoComponent";
import ModalGeneralComponent from "../../components/ModalGeneralComponent";
import styleform from "../../styles/form.module.scss";
import LoaderComponent from "../../components/LoaderComponent";
import AlertComponent from "../../components/AlertComponent";
import MoneyInputComponent from "../../components/MoneyInputComponent";
import stylegeneral from "../../styles/general.module.scss";
import {
  BuscarCliente,
  PostCliente,
  postventaRapidaDetalle,
} from "../../api/ApiVenta";
import { EditarPersona, PostPersona } from "../../api/Empleado";
import { useAuth } from "../../context/AuthContext";
import SelectComponent from "../../components/SelectComponent";
import { getTransporte } from "../../api/transporte";
import { abrirPdfVentasRapidas } from "../../api/Pdf";

const EditarFacturaPages = () => {
  const { id } = useParams();
  const [currentFactura, setCurrentFactura] = useState([]);
  const [data, setData] = useState([]);
  const [idFactura, setIdFactura] = useState("");
  const [loading, setLoading] = useState(false);
  const [showEliminar, setShowEliminar] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [mensaje, setMensaje] = useState("");
  const [alert, setAlert] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const [mensajealerta, setMensajealerta] = useState("");
  const [totalventas, setTotalVentas] = useState(0);
  const [totalPendiente, setTotalPendiente] = useState(0);
  const [currentItemIndex, setCurrentItemIndex] = useState(0);
  const [dataTransporte, setDatTransporte] = useState([]);
  const [showventa, setShowVenta] = useState(false);
  const [currentPersona, setCurrentPersona] = useState([]);
  const [idCliente, setIdCliente] = useState("");
  const [currentCliente, setCurrentCliente] = useState([]);
  const [control, setControl] = useState(false);
  const [isvendido, setIsvendido] = useState(false);
  const [descripcionAbono, setDescripcionAbono] = useState("");
  const [fecha_abono, setFecha_abono] = useState(null);
  const [hora_abono, setHora_abono] = useState(null);
  const [transporteID, setTransporteID] = useState("")
  const [formData, setFormData] = useState({
    producto: "",
    cantidad: "",
    precioUnidad: "",
    subtotal: "",
    pendiente_entrega: "",
  });


  const { isAdmin, idUser } = useAuth();
  const isVendedor = !isAdmin;
  const puedeEditar = !isVendedor || currentFactura?.tipo === "cotizacion";
  // El vendedor debe poder corregir a quién se entrega y la dirección de
  // envío aunque no pueda tocar el resto de una venta/elaboración ya cerrada.
  const puedeEditarEntrega = true;

  const [formDataCliente, setFormDataCliente] = useState({
    id_user: idUser,
    fecha_vencimiento: null,
    nombre: "",
    cedula: "",
    direccion: "",
    telefono: "",
    descuento: 0,
    transporte: 0,
    total_pagado: 0,
    fecha_creacion: null,
    nombre_conductor: "",
    celular_conductor: "",
    quien_recibe: "",
    tipo: "",
    descripcionElaboracion: "",
  });

  const navigate = useNavigate();

  const [formDataPersona, setFormDataPersona] = useState({
    cedula: "",
    nombre: "",
    apellido: "",
    direccion: "",
    celular: "",
  });

  const [checkboxes, setCheckboxes] = useState({
    isChecked: false,
    isCheckedDescuento: false,
    isCheckedpago: false,
    isCheckedPendiente: false,
    istransporte: false,
    debeActualizarCliente: false,
    cambiarCliente: false,
  });


  const handleCloseVenta = () => {
    setShowVenta(false);
  };

  // Manejar el cambio en el input
  const handleInputChangePersona = (event) => {
    const { name, value } = event.target;
    setFormDataPersona({
      ...formDataPersona,
      [name]: value,
    });
  };

  // Metodos para el popup de eliminar
  const handleCloseEliminar = () => setShowEliminar(false);

  // Metodos para el popup de eliminar
  const handleCloseEdit = () => {
    setShowEdit(false);
    setFormData({
      producto: "",
      cantidad: "",
      precioUnidad: "",
      subtotal: "",
      descuento: "",
      pendiente_entrega: "",
    });
  };

  const fetchFactura = async () => {
    setLoading(true);
    try {
      const factura = await obtenerDetalleventaR(id);
      const datafactura = factura?.res?.data;
      const dataCliente = factura?.res?.data?.Cliente?.Persona;
      setCurrentFactura(factura?.res?.data);
      setData(factura?.res?.data?.ventaRapidaDetalles);
      setIdFactura(factura?.res?.data?.id);
      setFormDataPersona({
        cedula: dataCliente?.cedula || datafactura?.cedula,
        nombre: dataCliente?.nombre || datafactura?.nombre,
        apellido: dataCliente?.apellido,
        direccion: dataCliente?.direccion || datafactura?.direccion,
        celular: dataCliente?.celular || datafactura?.celular,
      });
      setCurrentPersona(factura?.res?.data?.Cliente?.Persona);
      setFormDataCliente({
        fecha_vencimiento: datafactura?.fecha_vencimiento ? new Date(datafactura.fecha_vencimiento).toISOString().split("T")[0]
          : null,
        direccion: datafactura?.direccion,
        descuento: datafactura?.descuento,
        transporte: datafactura?.transporte,
        total_pagado: datafactura?.total_pagado,
        fecha_creacion: datafactura?.fecha_creacion
          ? new Date(datafactura.fecha_creacion).toISOString().split("T")[0]
          : null,
        nombre_conductor: datafactura?.nombre_conductor,
        celular_conductor: datafactura?.celular_conductor,
        quien_recibe: datafactura?.quien_recibe,
        tipo: datafactura?.tipo,

      })

      if (datafactura?.nombre_conductor || datafactura?.celular_conductor || datafactura?.transporte > 0) {
        setCheckboxes(prev => ({
          ...prev,
          istransporte: true
        }));
      }

      if (datafactura?.total_pagado > 0 || datafactura?.fecha_vencimiento) {
        setCheckboxes(prev => ({
          ...prev,
          isCheckedpago: true
        }));
      }

      if (datafactura?.descuento > 0) {
        setCheckboxes(prev => ({
          ...prev,
          isCheckedDescuento: true
        }));
      }

      // aquí podrías hacer la misma validación de tu otro fetchFactura con financiado vs abonos.
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  // metodo para verificar el cliente antes de registrar la compra
  const verificarCliente = async (e) => {
    e.preventDefault();
    const cedula = formDataPersona.cedula?.trim();
    if (!cedula) {
      setMensaje("Por favor ingrese una cédula válida");
      setTimeout(() => setMensaje(""), 3000);
      return;
    }

    try {
      setLoading(true);
      const res = await BuscarCliente(cedula);
      //Es lo primero que se debe hacer para ver la estructura de la data

      setControl(res?.success);
      if (res?.success && res.data) {
        const cliente = res.data;

        // ✅ Actualiza los datos del cliente encontrado
        setFormDataPersona((prev) => ({
          ...prev,
          cedula: cliente.cedula || cedula,
          nombre: cliente.nombre || "",
          apellido: cliente.apellido || "",
          direccion: cliente.direccion || "",
          celular: cliente.celular || "",
        }));

        // ✅ Guarda info adicional
        setCurrentPersona(cliente);
        setIdCliente(cliente.Clientes?.[0]?.id || "");
        setCurrentCliente(cliente.Clientes || []);

        setMensaje("Cliente encontrado ✅");
      } else {
        // 🚫 Cliente no existe
        setIdCliente("");
        setCurrentPersona([]);
        setCurrentCliente([]);
        setFormDataPersona((prev) => ({
          ...prev,
          nombre: "",
          apellido: "",
          direccion: "",
          celular: "",
        }));

        setMensaje("El cliente no existe ❌");
      }
    } catch (error) {
      console.error("Error verificando cliente:", error);
      setMensaje("Error al verificar el cliente");
    } finally {
      setLoading(false);
      setTimeout(() => setMensaje(""), 3000);
    }
  };


  // este metodo es para cambiar el cliente de la factura
  const crearCliente = async (cambiarCliente = false) => {
    if (!control || control === false) {
      const resP = await PostPersona(formDataPersona);
      if (resP.success) {
        const rescliente = await PostCliente(resP.data.idP);
        setIdCliente(rescliente?.data?.id);
        return rescliente?.data?.id; // ✅ devolvemos el ID
      }
    } else if (currentCliente.length === 0) {
      const rescliente = await PostCliente(currentPersona?.idP);
      setIdCliente(rescliente?.data?.id);
      if (cambiarCliente) {
        await EditarPersona(currentPersona?.idP, formDataPersona);
      }
      return rescliente?.data?.id; // ✅ devolvemos el ID
    } else {
      // Si ya existe cliente actual, devolvemos su ID directamente
      if (cambiarCliente) {
        await EditarPersona(currentPersona?.idP, formDataPersona);
      }
      return currentCliente[0]?.id;
    }
  };

 

  const actualizarVentaRapida = async () => {
    try {

      const saldoPendiente =
        Number(totalventas) +
        Number(formDataCliente.transporte ?? 0) -
        Number(formDataCliente.descuento ?? 0) -
        Number(formDataCliente.total_pagado ?? 0);

      const data = {
        ...formDataCliente,
        total: totalventas,
        estado:
          saldoPendiente > 0 && checkboxes.isCheckedpago
            ? "1"
            : totalPendiente > 0
              ? "2"
              : "0",
      };

      if (checkboxes.isCheckedpago && data.fecha_vencimiento === null) {
        setMensaje("Fecha de pago es obligatoria**");
        setTimeout(() => {
          setMensaje("");
        }, 5000);
        return;
      }
      setShowVenta(true);
      setLoading(true);

      if (checkboxes.cambiarCliente) {
        const clienteId = await crearCliente(checkboxes.cambiarCliente);
        await cambiarClienteCotizacion(id, clienteId)
      }

      if (checkboxes.debeActualizarCliente) {
        if (currentFactura?.Cliente == null || currentFactura?.Cliente == undefined) {
          let nombreApellido = `${formDataPersona.nombre} ${formDataPersona.apellido || ''}`.trim();
          await actualizarVentaR(currentFactura.id, {
            cedula: formDataPersona.cedula,
            nombre: nombreApellido,
            telefono: formDataPersona.celular

          });

        } else {
          await EditarPersona(currentPersona?.idP, formDataPersona);

        }

      }


      const resf = await actualizarVentaR(currentFactura.id, data);

      setMensajealerta(resf?.msg);
      if (resf.success) {
        setIsvendido(true);
      }
    } catch (error) {
      console.log(error);
    } finally {
      // 👈 se ejecuta siempre
      setLoading(false);

    }

    setTimeout(() => {
      setAlert(false);
      setMensaje("");
    }, 5000);
  };


  const crearVentaRapida = async () => {
    try {
      setShowVenta(true);
      setLoading(true);

      const fechaActual = new Date().toISOString().split("T")[0];
      const fechaFinal = formDataCliente.fecha_creacion || fechaActual;
      const res = await actualizarVentaR(currentFactura.id,
        {
          id_user: idUser,
          tipo: "venta",
          fecha_creacion: fechaFinal,
        });



      if (res.success) {
        if (formDataCliente.total_pagado > 0) {
          let descripcion = "Abono inicial " + descripcionAbono;
          await postAbonoVR(
            res?.data?.id,
            formDataCliente.total_pagado,
            descripcion,
            idUser,
            fecha_abono,
            hora_abono);
        }
        setIsvendido(false);
        setMensajealerta("La venta se realizó exitosamente");

      }

    } catch (error) {
      console.log(error);
    } finally {
      // 👈 se ejecuta siempre
      setLoading(false);
    }

    setTimeout(() => {
      setAlert(false);
      setMensaje("");
    }, 5000);
  }


  useEffect(() => {
    fetchFactura();
  }, [])

  // Manejar el cambio en el input
  const handleInputChangeCliente = (e) => {
    const { name, value } = e.target;
    setFormDataCliente((prev) => ({
      ...prev,
      [name]: name === "total_pagado" ? Number(value) : value, // 👈 convierte a número solo este campo
    }));
  };

  // Manejar el cambio en el input
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // este es el metodo para sacar el valor del check
  const handleCheckboxChange = (event) => {
    const { id, checked } = event.target;
    setCheckboxes((prevCheckboxes) => ({
      ...prevCheckboxes,
      [id]: checked,
    }));

    // ✅ Limpiar campos relacionados cuando se desmarca "isCheckedpago"
    if (id === "isCheckedpago" && !checked) {
      setFormDataCliente((prev) => ({
        ...prev,
        total_pagado: 0,
        fecha_vencimiento: null,
      }));

      setDescripcionAbono("");
      setFecha_abono(null);
      setHora_abono(null);
    }

    // ✅ Limpiar campos relacionados cuando se desmarca "istransporte"
    if (id === "istransporte" && !checked) {
      setFormDataCliente((prev) => ({
        ...prev,
        transporte: 0,
        celular_conductor: "",
        nombre_conductor: ""
      }));
    }

    // ✅ Limpiar campos relacionados cuando se desmarca "isCheckedDescuento"
    if (id === "isCheckedDescuento" && !checked) {
      setFormDataCliente((prev) => ({
        ...prev,
        descuento: 0,
      }));
    }
  };


  //Metodo para capturar los valotes de la descripcion
  const handleChangeDescripcion = (event) => {
    setDescripcionAbono(event.target.value);
  };

  // Este es el metodo  para capturar el valor de las fechas de los abonos
  const handleChangeFechaAbono = (event) => {
    setFecha_abono(event.target.value);
  };

  // Este es el metodo para capturar la hora de los abonos
  const handleChangeHoraAbono = (event) => {
    setHora_abono(event.target.value);
  };


  // metodo para agregar venta rapidas
  const aggVentarapida = async () => {

    try {

      setMensaje('Agregando el producto...');
      setLoading(true);

      if (formData.producto === "" || formData.cantidad === "" || formData.precioUnidad === "") {
        setMensaje('Los campos * son obligatorios');
        setLoading(false);
        setTimeout(() => {
          setMensaje("");
        }, 5000);
        return;
      }
      const cantidadNum = Number(formData.cantidad);
      const pendienteNum = Number(formData.pendiente_entrega) || 0;
      const precioNum = Number(formData.precioUnidad);

      const nuevoProducto = {
        producto: formData.producto,
        cantidad: cantidadNum,
        pendiente_entrega: pendienteNum,
        precioUnidad: precioNum,
        subtotal: cantidadNum * precioNum,
      };


      const detalle = await postventaRapidaDetalle(
        currentFactura?.id,
        [nuevoProducto]
      );
      if (detalle?.res?.success) {
        fetchFactura();
        setFormData({
          producto: "",
          cantidad: "",
          precioUnidad: "",
          subtotal: "",
          pendiente_entrega: "",
        })
        setMensaje('Producto agregado')
      }

      console.log(detalle);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
    setTimeout(() => {
      setMensaje("");
    }, 5000);
  };



  // calculamos el total de la compra
  useEffect(() => {
    if (!data) return;
    const calcularTotales = (ventaR) => {
      return ventaR.reduce(
        (acc, item) => {
          acc.total += Number(item.subtotal);
          acc.pendiente += Number(item.pendiente_entrega) || 0; // 👈 asumo que este es el campo
          return acc;
        },
        { total: 0, pendiente: 0 }
      );
    };

    const { total, pendiente } = calcularTotales(data);

    setTotalVentas(total);
    setTotalPendiente(pendiente); // 👈 otro estado para guardar el pendiente
  }, [data]);


  const handleShowEdit = (item, index) => {
    setFormData({
      producto: item.producto,
      cantidad: item.cantidad,
      precioUnidad: item.precioUnidad,
      pendiente_entrega: item.pendiente_entrega,
    });
    setCurrentItem(item);
    setCurrentItemIndex(index);
    setShowEdit(true);

  };

  // editar las ventas rapidas el detalle
  const editarVentaRapida = async () => {
    try {

      const cantidadNum = Number(formData.cantidad);
      const pendienteNum = Number(formData.pendiente_entrega) || 0;
      const precioNum = Number(formData.precioUnidad);
      setLoading(true);
      const updateProducto = {
        producto: formData.producto,
        cantidad: cantidadNum,
        pendiente_entrega: pendienteNum,
        precioUnidad: precioNum,
        subtotal: cantidadNum * precioNum,
      };
      const resRD = await actualizarVentaRD(currentItem?.id, updateProducto);
      if (resRD.success) {
        setMensajealerta(resRD?.msg);
        setShowEdit(false);
        setLoading(false);
        setAlert(true);
        fetchFactura();
      }

    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false);
    }


    setTimeout(() => {
      setAlert(false);
    }, 5000);
  };

  const handleShowEliminar = (item, index) => {
    setCurrentItemIndex(index);
    setCurrentItem(item);
    setShowEliminar(true);
  };

  const eliminarVentaRD = async () => {
    try {
      setLoading(true);
      const resRD = await deleteVentaRD(currentItem?.id);
      if (resRD?.success) {
        setMensajealerta(resRD?.msg);
        setLoading(false);
        setAlert(true);
        setShowEliminar(false);
        fetchFactura();
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false);
    }

    setTimeout(() => {
      setAlert(false);
    }, 5000);
  };



  const verificarfactura = async () => {
    //window.location.href = `/generarfacturaventaR/${idFactura}`;
    await abrirPdfVentasRapidas(idFactura);
    navigate('/venta-realizadas');
  };


  //Metodo para traer todo los transporte 
  const fetchTransporte = async (filters = {}) => {
    try {
      const res = await getTransporte(filters);
      setDatTransporte(res?.data);
    } catch (error) {
      console.error('Error al obtener los transportes:', error);
    }
  };

  useEffect(() => {
    fetchTransporte();
  }, []);

  //Metodo para obtener los transportes
  const obtenerdatosTransporte = (idSeleccionado) => {
    const transporteEncontrado = dataTransporte.find(
      (item) => item.id === idSeleccionado
    );

    if (!transporteEncontrado) return null;

    return {
      nombre: transporteEncontrado.Persona?.nombre,
      apellido: transporteEncontrado.Persona?.apellido,
      celular: transporteEncontrado.Persona?.celular,

    };
  };
  return (
    <Fragment>
      <div className="d-flex justify-content-center">
        <AlertComponent
          styleGroup="bg-soccess color-white"
          mensaje={mensajealerta}
          activaalert={alert}
        />
      </div>
      <HeaderComponent styleGroup="">
        <TitleH2Component styleGroup="box-text color-dark fw700 roboto mb-4">
          EDITAR {currentFactura?.tipo === "venta" ? "FACTURA" : "COTIZACION"}
        </TitleH2Component>
      </HeaderComponent>
      <div className="conatiner-global pt-3 pb-5">

        <section className="mb-3 border border-dark rounded p-3">
          <form action="" onSubmit={verificarCliente}>
            <div className="container">
              <TitleH4Component styleGroup="box-text color-madera text-center fw700 roboto mb-1">
                INFORMACION DEL COMPRADOR
              </TitleH4Component>
              <div
                className={`${styleform.checkbox} d-flex justify-content-start mb-2`}
              >
                <input
                  className=" me-2"
                  type="checkbox"
                  value=""
                  id="debeActualizarCliente"
                  checked={checkboxes.debeActualizarCliente}
                  onChange={handleCheckboxChange}
                  disabled={!puedeEditar}
                />
                <label className="color-madera fw700" htmlFor="recorddat">
                  Actualizar información cliente
                </label>
              </div>
              {currentFactura?.tipo === "cotizacion" && (
                <div
                  className={`${styleform.checkbox} d-flex justify-content-start mb-2`}
                >
                  <input
                    className=" me-2"
                    type="checkbox"
                    value=""
                    id="cambiarCliente"
                    checked={checkboxes.cambiarCliente}
                    onChange={handleCheckboxChange}
                    disabled={!puedeEditar}
                  />
                  <label className="color-madera fw700" htmlFor="recorddat">
                    Cambiar cliente
                  </label>
                </div>
              )}

              <div className="row gy-4 d-flex  align-items-center mb-4">
                {/**d-flex justify-content-end align-items-end*/}
                <div className="col-12 col-md-6 col-xl-3">
                  <InputComponent
                    label="Documento"
                    styleLabel="fw600 WorkSans"
                    styleGroup="me-2"
                    htmlFor="bloque"
                    type="text"
                    placeholder="Documento"
                    value={formDataPersona.cedula}
                    name="cedula"
                    onChange={handleInputChangePersona}
                    disabled={!puedeEditar}
                  //onKeyDown={handleKeyDown}
                  />
                  {!alert && (
                    <ParrafoComponent styleGroup="mt-2 color-danger fw400 WorkSans">
                      {mensaje}
                    </ParrafoComponent>
                  )}
                </div>

                {puedeEditar && (
                  <div className="col-12 col-md-6 col-xl-3">
                    <button
                      type="submit"
                      className={` btn ${stylebtn.btn} ${stylebtn.primary} ms-3`}
                    >
                      Verificar Cliente
                    </button>
                  </div>
                )}
              </div>
              <div className="row gy-4 ">
                <div className="col-12 col-md-6 col-xl-3">
                  <InputComponent
                    label="Nombre"
                    styleLabel="fw600 WorkSans"
                    styleGroup="me-2"
                    htmlFor="bloque"
                    type="text"
                    placeholder="Ingrese Nombre"
                    value={formDataPersona.nombre}
                    name="nombre"
                    onChange={handleInputChangePersona}
                    disabled={!puedeEditar}
                  />
                </div>
                <div className="col-12 col-md-6 col-xl-3">
                  <InputComponent
                    label="Apellido"
                    styleLabel="fw600 WorkSans"
                    styleGroup="me-2"
                    htmlFor="bloque"
                    type="text"
                    placeholder="Ingrese Apellido"
                    value={formDataPersona.apellido}
                    name="apellido"
                    onChange={handleInputChangePersona}
                    disabled={!puedeEditar}
                  />
                </div>
                <div className="col-12 col-md-6 col-xl-3">
                  <InputComponent
                    label="Telefono"
                    styleLabel="fw600 WorkSans"
                    styleGroup="me-2"
                    htmlFor="bloque"
                    placeholder="Ingresar telefono"
                    type="text"
                    value={formDataPersona.celular}
                    name="celular"
                    onChange={handleInputChangePersona}
                    disabled={!puedeEditar}
                  />
                </div>
                <div className="col-12 col-md-6 col-xl-3">
                  <InputComponent
                    label="Direccion"
                    styleLabel="fw600 WorkSans"
                    styleGroup="me-2"
                    htmlFor="bloque"
                    placeholder="Ingresar dirección"
                    type="text"
                    name="direccion"
                    value={formDataPersona.direccion}
                    onChange={handleInputChangePersona}
                    disabled={!puedeEditar}
                  />
                </div>

                <div className="col-12 col-md-6 col-xl-3 ">
                  <InputComponent
                    label="Quien Recibe"
                    styleLabel="fw600 WorkSans"
                    styleGroup="me-2"
                    htmlFor="bloque"
                    type="text"
                    placeholder="Recibido"
                    value={formDataCliente.quien_recibe}
                    name="quien_recibe"
                    onChange={handleInputChangeCliente}
                    disabled={!puedeEditarEntrega}
                  />
                </div>

                <div className="col-12 col-md-6 col-xl-3 ">
                  <InputComponent
                    label="Direccion de envío"
                    styleLabel="fw600 WorkSans"
                    styleGroup="me-2"
                    htmlFor="bloque"
                    type="text"
                    placeholder="direccion"
                    value={formDataCliente.direccion}
                    name="direccion"
                    onChange={handleInputChangeCliente}
                    disabled={!puedeEditarEntrega}
                  />
                </div>
              </div>
            </div>
          </form>
        </section>
        <Fragment>
          <div className="container-fluid border border-dark rounded p-2">
            <form action="" className="mt-3">
              <TitleH4Component styleGroup="box-text color-madera text-center fw700 roboto mb-4">
                REGISTRAR PRODUCTO A{" "}
                {currentFactura?.tipo === "venta" ? "VENDER" : "COTIZAR"}
              </TitleH4Component>

              <div className="row d-flex align-items-center ">
                <div className="col-12 col-sm-6 col-lg-3">
                  <InputComponent
                    label="Producto"
                    placeholder="Ingerse producto"
                    styleLabel="fw600 WorkSans"
                    styleGroup=" mb-2"
                    htmlFor="bloque"
                    type="text"
                    name="producto"
                    value={formData.producto}
                    onChange={handleInputChange}
                    disabled={!puedeEditar}
                  />
                </div>
                <div className="col-12 col-sm-6 col-lg-3">
                  <InputComponent
                    label="Cantidad"
                    placeholder="Ingerse cantidad"
                    styleLabel="fw600 WorkSans"
                    styleGroup=" mb-2"
                    htmlFor="bloque"
                    type="number"
                    name="cantidad"
                    value={formData.cantidad}
                    onChange={handleInputChange}
                    disabled={!puedeEditar}
                  />
                </div>
                <div className="col-12 col-sm-6 col-lg-3">
                  <MoneyInputComponent
                    label="Precio por unidad"
                    placeholder="Ingerse precio"
                    styleLabel="fw600 WorkSans"
                    styleGroup=" mb-2"
                    //styleGroup={`${stylegeneral.col}`}
                    type="number"
                    value={formData.precioUnidad}
                    name="precioUnidad"
                    onChange={handleInputChange}
                    disabled={!puedeEditar}
                  />
                </div>
                <div className="col-12 col-sm-6 col-lg-3">
                  <InputComponent
                    label="Pendiente por entregar"
                    placeholder="Ingerse cantidad"
                    styleLabel="fw600 WorkSans"
                    styleGroup=" mb-2"
                    htmlFor="bloque"
                    type="number"
                    name="pendiente_entrega"
                    value={formData.pendiente_entrega}
                    onChange={handleInputChange}
                    disabled={!puedeEditar}
                  />
                </div>
                {puedeEditar && (
                  <div className="col-12 d-flex justify-content-end">
                    <button
                      type="button"
                      onClick={aggVentarapida}
                      className={`${stylebtn.btn} ${stylebtn.primary}  mt-4 ${loading && stylebtn.disabled}`}
                      disabled={!loading ? false : true}
                    >
                      Registrar
                    </button>
                  </div>
                )}
              </div>
            </form>
          </div>

          <ParrafoComponent
            styleGroup={`color-danger text-center mt-3 fw700 WorkSans`}
          >
            {mensaje}
          </ParrafoComponent>
          <div className="table-responsive mt-4">
            <ParrafoComponent styleGroup=" color-madera fw700 WorkSans ">
              Total factura : ${" "}
              {(
                Number(totalventas) +
                Number(formDataCliente.transporte ?? 0) -
                Number(formDataCliente.descuento)
              ).toLocaleString("es-ES")}
            </ParrafoComponent>
            <ParrafoComponent styleGroup=" color-madera fw700 WorkSans ">
              Total financiado : ${" "}
              {formDataCliente.total_pagado > 0
                ? (
                  Number(totalventas) +
                  Number(formDataCliente.transporte ?? 0) -
                  Number(formDataCliente.descuento ?? 0) -
                  Number(formDataCliente.total_pagado ?? 0)
                ).toLocaleString("es-ES")
                : 0}
            </ParrafoComponent>
            <table className="table table-bordered tableGeneral">
              <thead>
                <tr>
                  <th scope="col " className="color-madera">
                    #
                  </th>
                  <th scope="col " className="color-madera">
                    Producto
                  </th>
                  <th scope="col " className="color-madera">
                    Cantidad
                  </th>
                  <th scope="col " className="color-madera">
                    Pendiente por entregar
                  </th>
                  <th scope="col" className="color-madera">
                    Precio x unidad
                  </th>
                  <th scope="col" className="color-madera">
                    Sub Total
                  </th>
                  {puedeEditar && (
                    <th scope="col" className="color-madera text-center">
                      Editar
                    </th>
                  )}
                  {puedeEditar && (
                    <th scope="col" className="color-madera text-center">
                      Eliminar
                    </th>
                  )}
                </tr>
              </thead>
              {data?.length !== 0 ? (
                <tbody>
                  {data?.map((item, index) => {
                    return (
                      <tr key={index}>
                        <th>{index + 1}</th>
                        <th className="text-center">{item.producto}</th>
                        <td className="text-center">{item.cantidad}</td>
                        <td className="text-center">
                          {item.pendiente_entrega}
                        </td>
                        <td className="text-center">
                          ${" "}
                          {Number(item.precioUnidad).toLocaleString("es-ES")}
                        </td>
                        <td className="text-center">
                          $ {Number(item.subtotal).toLocaleString("es-ES")}
                        </td>
                        {puedeEditar && (
                          <td>
                            <button
                              className={`${stylebtn.btn_desnudo} ${stylebtn.icon} ms-3 p-0 d-inline-flex`}
                              onClick={() => handleShowEdit(item, index)}
                            >
                              <Icon icon="raphael:edit" />
                            </button>
                          </td>
                        )}
                        {puedeEditar && (
                          <td>
                            <button
                              className={`${stylebtn.btn_desnudo} ${stylebtn.icon} ms-3 p-0 d-inline-flex color-danger`}
                              onClick={() => handleShowEliminar(item, index)}
                            >
                              <Icon icon="majesticons:delete-bin" />
                            </button>
                          </td>
                        )}
                      </tr>
                    );
                  })}
                </tbody>
              ) : (
                <tbody>
                  <tr>
                    <td colSpan={8} className="text-center">
                      SIN DATOS
                    </td>
                  </tr>
                </tbody>
              )}
            </table>

            {!alert && (
              <ParrafoComponent styleGroup="text-center color-danger fw400 WorkSans">
                {mensaje}
              </ParrafoComponent>
            )}
            <section className="mb-3">
              <div className="container">
                <div className="row gy-3 align-items-end">
                  {/* Columna izquierda: check + fecha */}
                  <div className="col-12 col-md-6 col-xl-3">
                    <InputComponent
                      label="Fecha de Facturación"
                      styleLabel="fw600 WorkSans"
                      styleGroup="mb-3"
                      htmlFor="bloque"
                      placeholder="Ingresar fecha"
                      type="date"
                      name="fecha_creacion"
                      value={formDataCliente.fecha_creacion}
                      onChange={handleInputChangeCliente}
                      disabled={!puedeEditar}
                    />
                    {/* Checkbox arriba */}
                    <div
                      className={`${styleform.checkbox} d-flex justify-content-start mb-2`}
                    >
                      <input
                        className=" me-2"
                        type="checkbox"
                        value=""
                        id="istransporte"
                        checked={checkboxes.istransporte}
                        onChange={handleCheckboxChange}
                      />
                      <label
                        className="color-madera fw700"
                        htmlFor="recorddat"
                      >
                        Transporte
                      </label>
                    </div>
                    {checkboxes.istransporte && (
                      <>
                        <MoneyInputComponent
                          label="Valor transporte"
                          placeholder="Ingrese transporte"
                          styleLabel="fw600 WorkSans"
                          styleGroup="mb-3"
                          htmlFor="transporte"
                          type="number"
                          name="transporte"
                          value={formDataCliente.transporte}
                          onChange={handleInputChangeCliente}
                        />

                        <SelectComponent
                          label="Transporte"
                          styleGroup={`${stylegeneral.wselect}`}
                          styleLabel="fw600 WorkSans color-madera"
                          options={dataTransporte.map((transporte) => ({
                            value: transporte.id,
                            label:
                              transporte?.Persona?.nombre +
                              " " +
                              transporte?.Persona?.apellido,
                          }))}
                          capOpcions={(v) => {
                            setTransporteID(v);
                            const datos = obtenerdatosTransporte(v);

                            if (datos) {
                              setFormDataCliente((prev) => ({
                                ...prev,
                                nombre_conductor: `${datos?.nombre} ${datos?.apellido}`,
                                celular_conductor: datos.celular,
                              }));
                            }
                          }}
                          customPlaceholder="Seleccionar"
                          name="transporte"
                          value={
                            dataTransporte.find(
                              (o) => o.value == transporteID,
                            ) || null
                          }
                          isClearable
                        />
                        <div className="mt-2">
                          {formDataCliente.nombre_conductor && (
                            <ParrafoComponent styleGroup=" color-madera fw400 WorkSans my-2">
                              Nombre: {formDataCliente.nombre_conductor}
                            </ParrafoComponent>
                          )}
                          {formDataCliente?.celular_conductor && (
                            <ParrafoComponent styleGroup=" color-madera fw400 WorkSans mb-2">
                              Celular: {formDataCliente?.celular_conductor}
                            </ParrafoComponent>
                          )}
                          {/* <InputComponent
                                                        label="Nombre del conductor"
                                                        styleLabel="fw600 WorkSans"
                                                        styleGroup="mb-3"
                                                        htmlFor="bloque"
                                                        placeholder="Nombre del conductor"
                                                        type="text"
                                                        name="nombre_conductor"
                                                        value={formDataCliente?.nombre_conductor}
                                                        onChange={handleInputChangeCliente}
                                                    />
                                                    <InputComponent
                                                        label="Numero de celular"
                                                        styleLabel="fw600 WorkSans"
                                                        styleGroup="mb-3"
                                                        htmlFor="bloque"
                                                        placeholder="3*******"
                                                        type="text"
                                                        name="celular_conductor"
                                                        value={formDataCliente?.celular_conductor}
                                                        onChange={handleInputChangeCliente}
                                                    />*/}
                        </div>
                      </>
                    )}

                    <div
                      className={`${styleform.checkbox} d-flex justify-content-start mb-2`}
                    >
                      <input
                        className=" me-2"
                        type="checkbox"
                        value=""
                        id="isCheckedpago"
                        checked={checkboxes.isCheckedpago}
                        onChange={handleCheckboxChange}
                        disabled={!puedeEditar}
                      />
                      <label
                        className="color-madera  fw700"
                        htmlFor="recorddat"
                      >
                        Abono
                      </label>
                    </div>

                    {checkboxes.isCheckedpago && (
                      <div>
                        <MoneyInputComponent
                          label="Valor abonado"
                          placeholder="Ingrese precio"
                          styleLabel="fw600 WorkSans"
                          styleGroup=" mb-2"
                          //styleGroup={`${stylegeneral.col}`}
                          type="number"
                          name="total_pagado"
                          disabled={
                            currentFactura?.tipo === "cotizacion"
                              ? false
                              : true
                          }
                          value={formDataCliente.total_pagado}
                          onChange={handleInputChangeCliente}
                        />
                        <InputComponent
                          label="Fecha de Pago"
                          styleLabel="fw600 WorkSans"
                          styleGroup="me-2 mb-2"
                          htmlFor="fechaPago"
                          type="date"
                          name="fecha_vencimiento"
                          value={formDataCliente.fecha_vencimiento}
                          onChange={handleInputChangeCliente}
                        />

                        <textarea
                          label="descripcion"
                          name="descripcionAbono"
                          placeholder="Descripción"
                          className="form-control mb-2"
                          rows={3}
                          value={descripcionAbono}
                          onChange={handleChangeDescripcion}
                          disabled={
                            currentFactura?.tipo === "cotizacion"
                              ? false
                              : true
                          }
                        ></textarea>

                        <InputComponent
                          label="Fecha del abono"
                          styleLabel="fw600 WorkSans"
                          styleGroup="mb-2"
                          htmlFor="bloque"
                          type="date"
                          name="fecha_abono"
                          value={fecha_abono}
                          onChange={handleChangeFechaAbono}
                          disabled={
                            currentFactura?.tipo === "cotizacion"
                              ? false
                              : true
                          }
                        />

                        <InputComponent
                          styleLabel="fw600 WorkSans"
                          htmlFor="bloque"
                          label="Hora del abono"
                          type="time"
                          value={hora_abono}
                          name="hora_abono"
                          onChange={handleChangeHoraAbono}
                          disabled={
                            currentFactura?.tipo === "cotizacion"
                              ? false
                              : true
                          }
                        />
                        <ParrafoComponent styleGroup="text-center color-danger fw400 WorkSans">
                          {mensaje}
                        </ParrafoComponent>
                      </div>
                    )}

                    <div
                      className={`${styleform.checkbox} d-flex justify-content-start mb-2`}
                    >
                      <input
                        className=" me-2"
                        type="checkbox"
                        value=""
                        id="isCheckedDescuento"
                        checked={checkboxes.isCheckedDescuento}
                        onChange={handleCheckboxChange}
                        disabled={!puedeEditar}
                      />
                      <label
                        className="color-madera  fw700"
                        htmlFor="recorddat"
                      >
                        Descuento
                      </label>
                    </div>

                    {checkboxes.isCheckedDescuento && (
                      <div>
                        <MoneyInputComponent
                          placeholder="Ingrese precio"
                          styleLabel="fw600 WorkSans"
                          styleGroup=" mb-2"
                          //styleGroup={`${stylegeneral.col}`}
                          type="number"
                          name="descuento"
                          value={formDataCliente.descuento}
                          onChange={handleInputChangeCliente}
                        />

                        <ParrafoComponent styleGroup="text-center color-danger fw400 WorkSans">
                          {mensaje}
                        </ParrafoComponent>
                      </div>
                    )}
                    {/**DESCRCIPCION */}
                    <div
                      className={`${styleform.checkbox} d-flex justify-content-start mb-2`}
                    >
                      <input
                        className=" me-2"
                        type="checkbox"
                        id="isCheckedDescripcion"
                        checked={checkboxes.isCheckedDescripcion}
                        onChange={handleCheckboxChange}
                        disabled={!puedeEditar}
                      />
                      <label
                        className="color-madera  fw700"
                        htmlFor="recorddat"
                      >
                        Descripción de pago
                      </label>
                    </div>

                    {checkboxes.isCheckedDescripcion && (
                      <div>
                        <textarea
                          label="descripcion"
                          name="descripcionElaboracion"
                          placeholder="Descripción"
                          className="form-control mb-2"
                          rows={3}
                          value={formDataCliente?.descripcionElaboracion}
                          onChange={handleInputChangeCliente}
                        ></textarea>
                      </div>
                    )}
                  </div>

                  {/* Botón totalmente a la derecha */}
                  <div className="col d-flex justify-content-end gap-4">
                    {currentFactura?.tipo === "cotizacion" && (
                      <button
                        type="submit"
                        className={`${stylebtn.btn} ${stylebtn.primary}  mt-4 d-none`}
                        onClick={crearVentaRapida}
                      >
                        {"Despachar"}
                      </button>
                    )}

                    <button
                      type="submit"
                      className={`${stylebtn.btn} ${stylebtn.primary}  mt-4`}
                      onClick={actualizarVentaRapida}
                    >
                      {"Actualizar"}
                    </button>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </Fragment>
      </div>

      <section>
        <ModalGeneralComponent
          ModalHeader={false}
          titulo="Información del cliente"
          styleGroup={`d-flex align-items-center modal-general `}
          styleBody={`${"bg-gris-modal "}`}
          styleTitle={
            "box-text color-madera fw700 roboto text-center WorkSans"
          }
          show={showventa}
          handleClose={handleCloseVenta}
        >
          {loading ? (
            <LoaderComponent styleGroup="mt-5" />
          ) : (
            <div>
              <div className="d-flex justify-content-end mb-0 align-items-center mb-3">
                <button
                  type="button"
                  className={`btn ${stylebtn.btn} ${stylebtn.primary} me-3`}
                  onClick={verificarfactura}
                >
                  Generar factura
                </button>
                <button
                  type="button"
                  className={`btn ${stylebtn.btn_desnudo} ${stylebtn.icon} p-0 d-inline-flex`}
                  onClick={handleCloseVenta}
                >
                  <Icon icon="mdi:close-thick" />
                </button>
              </div>
              <TitleH2Component styleGroup="box-text color-soccess fw700 roboto mb-0 text-center WorkSans">
                {mensajealerta}
              </TitleH2Component>

              {isvendido && currentFactura?.tipo === "cotizacion" && (
                <div className="mt-3">
                  <TitleH2Component styleGroup="box-text color-soccess fw700 roboto mb-0 text-center WorkSans">
                    ¿Desea vender la cotización editada?
                  </TitleH2Component>
                  <div className="d-flex align-items-center justify-content-end gap-2 mt-4">
                    <button
                      type="button"
                      className={`btn ${stylebtn.btn} ${stylebtn.primary} me-3`}
                      onClick={handleCloseVenta}
                    >
                      No
                    </button>
                    <button
                      type="button"
                      className={`btn ${stylebtn.btn} ${stylebtn.primary} me-3`}
                      onClick={crearVentaRapida}
                    >
                      Si
                    </button>
                  </div>
                </div>
              )}
            </div>
          )}
        </ModalGeneralComponent>
      </section>

      {/** modal editar informacion de venta rapdia**/}
      <section>
        <ModalGeneralComponent
          ModalHeader
          titulo="Editar la Informacion"
          styleGroup={`d-flex align-items-center modal-general `}
          styleTitle={
            "box-text color-madera fw700 roboto text-center WorkSans"
          }
          show={showEdit}
          handleClose={handleCloseEdit}
        >
          {loading ? (
            <LoaderComponent styleGroup="mt-5" />
          ) : (
            <form action="">
              <div className="container">
                <div className="row">
                  <div className="col-12 col-sm-6">
                    <InputComponent
                      label="Producto"
                      placeholder="Ingerse producto"
                      styleLabel="fw600 WorkSans"
                      styleGroup=" mb-2"
                      htmlFor="bloque"
                      type="text"
                      name="producto"
                      value={formData.producto}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="col-12 col-sm-6">
                    <InputComponent
                      label="Cantidad"
                      placeholder="Ingerse producto"
                      styleLabel="fw600 WorkSans"
                      styleGroup=" mb-2"
                      htmlFor="bloque"
                      type="number"
                      name="cantidad"
                      value={formData.cantidad}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="col-12 col-sm-6">
                    <MoneyInputComponent
                      label="Precio"
                      placeholder="Ingerse precio"
                      styleLabel="fw600 WorkSans"
                      styleGroup=" mb-2"
                      htmlFor="bloque"
                      type="number"
                      value={formData.precioUnidad}
                      onChange={handleInputChange}
                      name="precioUnidad"
                    />
                  </div>
                  <div className="col-12 col-sm-6">
                    <InputComponent
                      label="Pendiente por entregar"
                      placeholder="Ingerse cantidad"
                      styleLabel="fw600 WorkSans"
                      styleGroup=" mb-2"
                      htmlFor="bloque"
                      type="number"
                      name="pendiente_entrega"
                      value={formData.pendiente_entrega}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
              </div>

              <div className="d-flex justify-content-end">
                <button
                  type="button"
                  onClick={handleCloseEdit}
                  className={`btn ${stylebtn.btn} ${stylebtn.danger} `}
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  className={` btn ${stylebtn.btn} ${stylebtn.primary} ms-3`}
                  onClick={editarVentaRapida}
                >
                  Continuar
                </button>
              </div>
            </form>
          )}
        </ModalGeneralComponent>
      </section>

      {/** modal eliminar un producto del carrito **/}
      <section>
        <ModalGeneralComponent
          styleGroup="d-flex align-items-center modal-general "
          styleTitle={
            "box-text color-madera fw700 roboto text-center WorkSans"
          }
          show={showEliminar}
          handleClose={handleCloseEliminar}
        >
          {loading ? (
            <LoaderComponent styleGroup="mt-5" />
          ) : (
            <form action="">
              <TitleH2Component styleGroup="box-text color-madera fw700 roboto mb-4 text-center">{`Seguro que quiere eliminar el producto con nombre ${currentItem?.producto} ?`}</TitleH2Component>

              <div className="d-flex justify-content-end">
                <button
                  type="button"
                  onClick={handleCloseEliminar}
                  className={`btn ${stylebtn.btn} ${stylebtn.danger} `}
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  className={`btn ${stylebtn.btn} ${stylebtn.primary} ms-3`}
                  onClick={eliminarVentaRD}
                >
                  SI
                </button>
              </div>
            </form>
          )}
        </ModalGeneralComponent>
      </section>
    </Fragment>
  );
}
export default EditarFacturaPages;